module.exports = __webpack_public_path__ + "c8708c7ae9f1ccfd893ee01efdf0ac51.otf";